import React from "react";
import SlidingPane from "react-sliding-pane";
import { ReactComponent as Closy } from "assets/svgs/closy.svg";
import ScheduledOrders from "components/account/subscription/scheduled-orders";
import { useSelector, useDispatch } from "react-redux";
import { TOGGLE_SCHEDULED_ORDERS_MODAL } from "utils/action-types";
import { isDesktop } from "utils/device-detect";
import { useGlobalContext } from "context/global";

const ScheduledOrdersModal = () => {
	const { translation } = useGlobalContext();
	const { isScheduledOrdersModalOpen } = useSelector((state) => state.account.subscription);

	const dispatch = useDispatch();

	const toggle = () => {
		// If modal is currently open, we're about to close it, need when user rechedules from profile settings
		if (isScheduledOrdersModalOpen) {
			const url = new URL(window.location.href);
			if (url.searchParams.get("setting") === "change-next-delivery") {
				url.searchParams.delete("setting");
				window.history.replaceState({}, "", url);
			}
		}
	
		dispatch({ type: TOGGLE_SCHEDULED_ORDERS_MODAL });
	};
	

	return (
		<>
			<SlidingPane
				from="right"
				width={isDesktop() ? "360px" : "90%"}
				shouldCloseOnEsc
				overlayClassName="z-50 bg-white mx-auto"
				isOpen={isScheduledOrdersModalOpen}
				hideHeader
				onRequestClose={toggle}
			>
				<div className="flex flex-col px-3 pt-5 pb-2.5 md:py-5 md:px-8 sticky top-0 z-[51] bg-white">
					<div className="flex justify-between rounded-t sticky top-0 bg-white z-10">
						<p className="text-body ">{translation.subscription?.change_billing_cycle}</p>
						<button onClick={toggle}>
							<Closy />
						</button>
					</div>
					<p className="text-gray-400 w-4/5">
						{translation?.subscription?.scheduled_orders_message}
					</p>
				</div>
				<ScheduledOrders />
			</SlidingPane>
		</>
	);
};

export default ScheduledOrdersModal;